<script setup lang="ts">
    import { ref } from 'vue';
    import { http } from '@/shared/httpWrapper';
    import { genericViewQueryAsText } from '@/shared/helpers/api';

    export type ClientApplication = {
        guid: string;
        description: string;
        objectId: string;
    };

    const selectedClient = defineModel<ClientApplication | null>();

    type Props = {
        label?: string;
    };

    const props = withDefaults(defineProps<Props>(), {
        label: 'Client application'
    });

    const clients = ref<ClientApplication[]>([]);
    const loading = ref<boolean>(true);
    const errorMessage = ref<string | null>(null);

    async function init(): Promise<void> {
        try {
            clients.value = (await genericViewQueryAsText(http, `
                SELECT name as guid, description, objectId
                FROM CommonLibraryClientApplications
                WHERE isValid = 1
                ORDER BY description
            `)).data as ClientApplication[];
        } catch {
            errorMessage.value = 'Something went wrong loading client list';
        }
        loading.value = false;
    }

    function onSelect(option: ClientApplication): void {
        selectedClient.value = option;
    }

    init();
</script>

<template>
    <b-field
        :label="props.label"
        :type="errorMessage ? 'is-danger' : ''"
        :message="errorMessage">
        <b-select
            v-model="selectedClient"
            placeholder="Select a client application"
            :loading="loading"
            expanded
            @update:model-value="onSelect">
            <option
                v-for="c in clients"
                :key="c.guid"
                :value="c">
                {{ c.description }}
            </option>
        </b-select>
    </b-field>
</template>
